export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "inner-setup.worker.ab486162490ed5b41a72.worker.js");
}
